import { render, staticRenderFns } from "./VtPerPageSelector.vue?vue&type=template&id=421ae61b"
import script from "./VtPerPageSelector.vue?vue&type=script&lang=js"
export * from "./VtPerPageSelector.vue?vue&type=script&lang=js"
import style0 from "./VtPerPageSelector.vue?vue&type=style&index=0&id=421ae61b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports